import { useEffect, useState } from "react";
import { authStorage } from "../../../auth";
import { createAmProject, getAmProjects } from "../../projects/amProject.client";
import { PS_URLS } from "../../../core";
import { useMessages } from "../../../ui/MessagesProvider";
import { PageLoading } from "../../../ui/Loading";
import { useHistory, useLocation } from "react-router-dom";
import { checkENodeConnectionStatus } from "../../icp4/icp4.client";
// import { checkENodeConnectionStatus } from "../../icp4/icp4.client";

interface AuthProps {
    render?: () => JSX.Element;
    children?: JSX.Element;
}

export function ICP4AuthWrapper({render, children}: AuthProps): JSX.Element {
  const company = authStorage.getCompany();
  const companyId = company.id;
  const [mandatoryAttachmentsExist, setMandatoryAttachmentsExist] = useState<boolean>(false);
  const [IsProjectLinkedWithEnode, setIsProjectLinkedWithEnode] = useState<boolean>(false);
  const [firstProjectId, setFirstProjectId] = useState<string>();
  const [isLoading, setIsLoading] = useState(true);
  const {clear, error} = useMessages();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const skipDocumentUpload = searchParams.get('skip-icp4-document-upload') === 'true';

  const companyHasAlreadyBeenOnboarded = authStorage.getMaybeUser()?.company?.accessRequestAccepted;

  useEffect(() => {
      if (render && children) console.error("You shouldn't use render and children at the same time")
      else if (!render && !children) console.error("You should use render or children")
  }, [render, children])


  useEffect(() => {
      if(companyHasAlreadyBeenOnboarded) return;
      async function load() {
        setIsLoading(true);
        let projects = await getAmProjects(companyId);
        let firstProjectIdLocal = projects?.[0]?.id;
        if(!projects?.[0]?.id) {
          let project = await createAmProject(companyId);
          firstProjectIdLocal = project.id;
        }
        const {isLinked} = await checkENodeConnectionStatus(companyId, firstProjectIdLocal);
        setIsProjectLinkedWithEnode(isLinked);
        setFirstProjectId(firstProjectIdLocal);
        setMandatoryAttachmentsExist(projects?.some((p)=>(p.attachments && p.attachments?.length >= 2)))
        setIsLoading(false);
      }
      load().catch(e => error(e.message));
    }, [companyId, companyHasAlreadyBeenOnboarded]);
    
    useEffect(() => {
      if(isLoading) return;
      if (companyHasAlreadyBeenOnboarded) {
        return;
      } else if(firstProjectId && IsProjectLinkedWithEnode){
        history.push(`${PS_URLS(companyId).icp4FirstSiteVendorOnboarding(firstProjectId)}?skip-icp4-document-upload=true`);
        return;
      } else if(firstProjectId && !mandatoryAttachmentsExist){
        if(skipDocumentUpload){
          history.push(`${PS_URLS(companyId).icp4FirstSiteVendorOnboarding(firstProjectId)}?skip-icp4-document-upload=true`);
          return;
        } else {
          history.push(`${PS_URLS(companyId).icp4FirstSiteDocumentsUpload(firstProjectId)}?skip-icp4-document-upload=${skipDocumentUpload}`);
          return;
        }
      } else if(firstProjectId && mandatoryAttachmentsExist){
        history.push(`${PS_URLS(companyId).icp4FirstSiteVendorOnboarding(firstProjectId)}?skip-icp4-document-upload=${skipDocumentUpload}`);
        return;
      }
    }, [isLoading, companyHasAlreadyBeenOnboarded, IsProjectLinkedWithEnode, firstProjectId, mandatoryAttachmentsExist, skipDocumentUpload]);
    
    if(!companyHasAlreadyBeenOnboarded && isLoading){
      return <PageLoading />
    }

    return render ? render() : <>{children}</>;

}